var map = {
	"./error-page.webp": 2370,
	"./maintanance.webp": 2371,
	"./miscellaneous-bg.webp": 2372,
	"./miscellaneous-mobile-bg.webp": 2373,
	"./restriction.webp": 2374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 480;